import { WINDOW_CONSTANTS, Windows95Window } from "../Windows95Window";
import TaggedText from "pixi-tagged-text";
import { TextStyleSet } from "pixi-tagged-text/dist/types";
import { Win95MailWindow } from "./Win95MailWindow";
import { ScrollBar } from "../ScrollBar";
import { tsthreeConfig } from "../../../config/tsthreeConfig";
import { DisplayObject, Graphics, NineSlicePlane, Texture } from "pixi.js";
import { getDimensionsOfTaggedText } from "../../../engine/HelperFunctions/getWidthOfTaggedText";
import { Plane } from "three";
import { PlayerDataSingleton } from "../../Logic/PlayerDataSingleton";
import { IVector2 } from "../../../engine/Types/IVector2";
import { IWindowState } from "../../Types/IWindowState";

export class Win95MailPopoutWindow extends Windows95Window {

    private contentsText: TaggedText;
    private textStyle: TextStyleSet;
    private selectedMailBg: NineSlicePlane;
    private scrollBar: ScrollBar;
    private _contentsMask: Graphics;

    constructor(_settings: {
        textStyle: TextStyleSet;
        openLink: (url: string, caseId?: string) => void;
        onClose: () => void;
        onMinimise: () => void;
        windowStateRef: IWindowState<Win95MailPopoutWindow>;
    }) {
        super({
            title: "Email",
            iconKey: "read-icon",
            windowStateRef: _settings.windowStateRef,

            dimensions: {
                width: 500,
                height: 600
            },

            onMinimise: _settings.onMinimise,
            onClose: _settings.onClose,
        });

        const selectedMailBg = this.selectedMailBg = new NineSlicePlane(
            ENGINE.getPIXIResource("inner-container-nineslice") as Texture
        );
        selectedMailBg.width = 500 - 4;
        selectedMailBg.height = 600 - 4 - 36;
        selectedMailBg.position.set(2, 2);
        this.contentContainer.addChild(selectedMailBg);

        this.textStyle = JSON.parse(JSON.stringify(_settings.textStyle));

        const contentsText = this.contentsText = new TaggedText("",
            this.textStyle,
            {
                drawWhitespace: true,
            }
        );
        contentsText.position.set(6, 6);
        this.contentContainer.addChild(contentsText);

        const mask = this._contentsMask = this.createMask({
            x: selectedMailBg.width,
            y: selectedMailBg.height,
        });
        this.contentsText.mask = mask;
        this.contentContainer.addChild(mask);

        // new ScrollBar({
        //     height: selectedMailBg.height - 6,
        //     onScroll: (_currIncrements: number) => {
        //         contentsText.position.set(
        //             contentsText.position.x,
        //             (_currIncrements * -16) + 10
        //         );
        //     }
        // });
        const mailContentsScrollbar = this.scrollBar = this.createScrollbar(
            selectedMailBg.height - 6,
            contentsText
        );
        mailContentsScrollbar.position.set(selectedMailBg.width + 1, 4);
        this.contentContainer.addChild(mailContentsScrollbar);

        let pointerOver = false;
        this.selectedMailBg.interactive = true;
        this.selectedMailBg.buttonMode = false;
        this.selectedMailBg.on("pointerover", () => {
            pointerOver = true;
        });
        this.selectedMailBg.on("pointerout", () => {
            pointerOver = false;
        });
        document.addEventListener("wheel", (ev) => {
            if(
                !this.visible ||
                !pointerOver
            ) return;
            this.scrollBar.scrollWheel((ev.deltaY / 100));
        });
    }

    private createMask(dimensions: IVector2): Graphics {
        const mask = new Graphics();
        mask.beginFill(0xff0000, 1);
        mask.drawRect(0, 0,
            dimensions.x - 4,
            dimensions.y - 4
        );
        mask.endFill();
        mask.position.set(2, 2);
        return mask;
    }

    private createScrollbar(_height: number, _targetElement: DisplayObject): ScrollBar {
        return new ScrollBar({
            height: _height,
            onScroll: (_currIncrements: number) => {
                _targetElement.position.set(
                    _targetElement.position.x,
                    (_currIncrements * -16) + 10
                );
            }
        });
    }

    public update(
        _text: string,
        _subject: string,
        _onHyperlinkClicked: (url: string, caseId?: string) => void
    ): void {
        this.textStyle.default.fontSize
            = this.contentsText.defaultStyle.fontSize
                = Math.round(11 * PlayerDataSingleton.getMailboxZoom());
        this.textStyle.default.wordWrapWidth = (tsthreeConfig.width - 32);
        this.textStyle.default.wordWrap = true;
        this.contentsText.text = _text;
        this.contentsText.update();
        this.windowName = _subject;
        Win95MailWindow.updateHyperlinksInText(this.contentsText, _onHyperlinkClicked);
        const dimensions = getDimensionsOfTaggedText(this.contentsText);
        this.selectedMailBg.width = dimensions.x + 24;
        this.selectedMailBg.height = Math.min(dimensions.y + 32, 600);
        this.resize({
            x: this.selectedMailBg.width + 4,
            y: this.selectedMailBg.height,
        });
        this.scrollBar.parent.removeChild(this.scrollBar);
        this.scrollBar.destroy();
        this.scrollBar = null;
        const mailContentsScrollbar = this.scrollBar = this.createScrollbar(
            this.selectedMailBg.height - 6,
            this.contentsText
        );
        mailContentsScrollbar.position.set(this.selectedMailBg.width + 1, 4);
        this.contentContainer.addChild(mailContentsScrollbar);
        this.scrollBar.update(
            Math.ceil((dimensions.y - (this.selectedMailBg.height - 40 - 6)) / 16)
        );
        this._contentsMask.parent.removeChild(this._contentsMask);
        this._contentsMask.destroy();
        const mask = this._contentsMask = this.createMask({
            x: this.selectedMailBg.width,
            y: this.selectedMailBg.height,
        });
        this.contentsText.mask = mask;
        this.contentContainer.addChild(mask);
        this.contentsText.position.set(6, 6);
    }
}